import React, { Component } from 'react';
import ReactEcharts from 'react-echarts-component';
import echarts from 'echarts';
import moment from 'moment';

export default class WorkspaceChartHelper {
	constructor() {
		this.colorWheel = ["#007eb5","#489abd","#79b4c5","#aacdd1","#77c7c4","#41bfa9","#00b582"]; /* Predicted Pallette*/
		
		//this.colorWheel = ["#007EB5", "#597ECA", "#9979D0", "#D36EC2", "#FE66A3", "#FF6C78", "#FF8548", "#FFA600"]; /* MVP Pallette*/

		/*this.colorWheel = ['#76FF03', '#C6FF00', '#FFEA00', '#FFC400', '#FF9100', '#FF3D00',
            '#FF1744', '#F50057', '#D500F9', '#651FFF', '#3D5AFE', '#2979FF', '#00B0FF', '#00E5FF',
            '#1DE9B6', '#00E676', '#64DD17', '#AEEA00', '#FFD600', '#FFAB00', '#FF6D00', '#DD2C00', '#D50000',
            '#C51162', '#AA00FF', '#6200EA', '#304FFE', '#2962FF', '#0091EA', '#00B8D4', '#00BFA5', '#00C853',
            '#B2FF59', '#EEFF41', '#FFFF00', '#FFD740', '#FFAB40', '#FF6E40', '#FF5252', '#FF4081', '#E040FB',
            '#7C4DFF', '#536DFE', '#448AFF', '#40C4FF', '#18FFFF', '#64FFDA', '#69F0AE']; /* Rainbow Pallette */ 

		this.generateBarChart = this.generateBarChart.bind(this);
		this.generateStackedBarChart = this.generateStackedBarChart.bind(this);
		this.generateLineChart = this.generateLineChart.bind(this);
		this.generatePieChart = this.generatePieChart.bind(this);
	}

	generateBarChart(baseData) {

		let series = []

		Object.keys(baseData.data).forEach(key => {
			series.push({
				name: key,
				type: 'bar',
				barGap: 0,
				data: baseData.data[key]
			})
		})



		return (
			<ReactEcharts
				className={"workspace-chart"}
				height={'100%'}
				notMerge={true}
				option={{
					color: this.colorWheel,
					title: {
						show: false,
						text: ""
					},
					tooltip: {
						trigger: 'axis',
						formatter: function(params, index) {
							let text = '';
							params.forEach(el => {
								if(el !== undefined) {
									let colorSpan = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' + el.color + '"></span>';
									if(baseData.dataType[el.seriesName] === "MNY") {
										text +=  '<p style="color:rgb(255,255,255); font:14px / 21px Microsoft YaHei;margin-bottom:0px">' + colorSpan  + el.seriesName + ": " + el.value.toLocaleString("en-US", {style:"currency", currency:"USD"})+ '</p>';
									} else if(baseData.dataType[el.seriesName] === "PCT") {
										text +=  '<p style="color:rgb(255,255,255); font:14px / 21px Microsoft YaHei;margin-bottom:0px">' + colorSpan  + el.seriesName + ": " + el.value + '%' + '</p>';
									} else {
										text +=  '<p style="color:rgb(255,255,255); font:14px / 21px Microsoft YaHei;margin-bottom:0px">' + colorSpan  + el.seriesName + ": " + el.value + '</p>';
									}
								}
							})
							return text;
						}
					},
					grid: {
						left: '50px',
						bottom: '70px',
						top: '10px',
						right: '10px'
					},
					xAxis: {
						type: 'category',
						data: baseData.xAxis,
						axisLabel: {
							rotate: 45,
							formatter: (value, index) => {
								return value.length > 12 ? value.substring(0, 10) + "..." : value
							},
						}
					},
					yAxis: {
						type: 'value',
						axisLabel: {
							formatter: function (label) {
								let rl = label;
								let num = parseFloat(label);
								if (num >= 1000000) {
									rl = (num / 1000000.0).toFixed(1) + 'M';
								} else if (num >= 1000) {
									rl = (num / 1000.0).toFixed(0) + 'K';
								} else {
									rl = label;
								}

								return rl;
							}
						},
					},
					series: series
				}}
			/>
		)
	}

	generateStackedBarChart(baseData) {

		let series = []

		Object.keys(baseData.data).forEach(key => {
			series.push({
				name: key,
				type: 'bar',
				barGap: 0,
				stack: "stack",
				data: baseData.data[key]
			})
		})

		return (
			<ReactEcharts
				className={"workspace-chart"}
				height={'100%'}
				notMerge={true}
				option={{
					color: this.colorWheel,
					title: {
						show: false,
						text: ""
					},
					tooltip: {
						trigger: 'axis',
						formatter: function(params, index) {
							let text = '';
							params.forEach(el => {
								if(el !== undefined) {
									let colorSpan = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' + el.color + '"></span>';
									if(baseData.dataType[el.seriesName] === "MNY") {
										text +=  '<p style="color:rgb(255,255,255); font:14px / 21px Microsoft YaHei;margin-bottom:0px">' + colorSpan  + el.seriesName + ": " + el.value.toLocaleString("en-US", {style:"currency", currency:"USD"})+ '</p>';
									} else if(baseData.dataType[el.seriesName] === "PCT") {
										text +=  '<p style="color:rgb(255,255,255); font:14px / 21px Microsoft YaHei;margin-bottom:0px">' + colorSpan  + el.seriesName + ": " + el.value + '%' + '</p>';
									} else {
										text +=  '<p style="color:rgb(255,255,255); font:14px / 21px Microsoft YaHei;margin-bottom:0px">' + colorSpan  + el.seriesName + ": " + el.value + '</p>';
									}
								}
							})
							return text;
						}
					},
					grid: {
						left: '50px',
						bottom: '70px',
						top: '10px',
						right: '10px'
					},
					xAxis: {
						type: 'category',
						data: baseData.xAxis,
						axisLabel: {
							rotate: 45,
							formatter: (value, index) => {
								return value.length > 12 ? value.substring(0, 10) + "..." : value
							},
						}
					},
					yAxis: {
						type: 'value',
						axisLabel: {
							formatter: function (label) {
								let rl = label;
								let num = parseFloat(label);
								if (num >= 1000000) {
									rl = (num / 1000000.0).toFixed(1) + 'M';
								} else if (num >= 1000) {
									rl = (num / 1000.0).toFixed(0) + 'K';
								} else {
									rl = label;
								}

								return rl;
							}
						},
					},
					series: series
				}}
			/>
		)
	}

	generateLineChart(data) {

		let series = data.data;

		return (
			<ReactEcharts
				className={"workspace-chart"}
				height={'100%'}
				notMerge={true}
				option={{
					color: this.colorWheel,
					title: {
						show: false,
						text: ""
					},
					tooltip: {
						trigger: 'axis',
						formatter: function(params, index) {
							let text = '<p style="color:rgb(255,255,255); font:14px / 21px Microsoft YaHei;margin-bottom:0px">' + params[0].axisValueLabel + '</p>';
							params.forEach(el => {
								if(el !== undefined) {
									let colorSpan = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' + el.color + '"></span>';
									if(data.dataType === "MNY") {
										text +=  '<p style="color:rgb(255,255,255); font:14px / 21px Microsoft YaHei;margin-bottom:0px">' + colorSpan  + el.seriesName + ": " + el.value[1].toLocaleString("en-US", {style:"currency", currency:"USD"})+ '</p>';
									} else if(data.dataType === "PCT") {
										text +=  '<p style="color:rgb(255,255,255); font:14px / 21px Microsoft YaHei;margin-bottom:0px">' + colorSpan  + el.seriesName + ": " + el.value[1] + '%' + '</p>';
									} else {
										text +=  '<p style="color:rgb(255,255,255); font:14px / 21px Microsoft YaHei;margin-bottom:0px">' + colorSpan  + el.seriesName + ": " + el.value[1] + '</p>';
									}
								}
							})
							return text;
						}
					},
					grid: {
						left: '50px',
						bottom: '70px',
						top: '10px',
						right: '10px'
					},
					xAxis: {
						type: 'time',
						axisLabel: {
							formatter: (value, index) => {
								return moment(value).format("MM/DD/YYYY")
							},
							rotate: 45
						}
					},
					yAxis: {
						type: 'value',
						axisLabel: {
							formatter: function (label) {
								let rl = label;
								let num = parseFloat(label);
								if (num >= 1000000) {
									rl = (num / 1000000.0).toFixed(1) + 'M';
								} else if (num >= 1000) {
									rl = (num / 1000.0).toFixed(0) + 'K';
								} else {
									rl = label;
								}

								return rl;
							}
						},
					},
					series: series
				}}
			/>
		)
	}

	generatePieChart(chartData) {
		let seriesData = [];
		let legendData = [];

		for (let i = 0; i < chartData.data.legend.length; i++) {

			let name = chartData.data.legend[i];

			legendData.push(name);
			seriesData.push({
				name: name,
				value: chartData.data.data[0][i]
			})
		}

		return (
			<ReactEcharts
				className={"workspace-chart"}
				height={'100%'}
				notMerge={true}
				option={{
					color: this.colorWheel,
					title: {
						show: false,
						text: ""
					},
					tooltip: {
						trigger: 'item',
						formatter: function(params, index) {
							let text = '';
							if(params !== undefined) {
								let colorSpan = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' + params.color + '"></span>';
								if(chartData.dataType === "MNY") {
									text +=  '<p style="color:rgb(255,255,255); font:14px / 21px Microsoft YaHei;margin-bottom:0px">' + colorSpan  + params.data.name + ": " + params.percent + "% (" + params.data.value.toLocaleString("en-US", {style:"currency", currency:"USD"})+ ')</p>';
								} else if(chartData.dataType === "PCT") {
									text +=  '<p style="color:rgb(255,255,255); font:14px / 21px Microsoft YaHei;margin-bottom:0px">' + colorSpan  + params.data.name + ": " + params.percent + '%' + '</p>';
								} else {
									text +=  '<p style="color:rgb(255,255,255); font:14px / 21px Microsoft YaHei;margin-bottom:0px">' + colorSpan  + params.data.name + ": " + params.percent + "% (" + params.data.value + ")" + '</p>';
								}
							}
							return text;
						}
					},
					series: [
						{
							type: 'pie',
							radius: '70%',
							center: ['50%', '50%'],
							data: seriesData,
							itemStyle: {
								normal: {
									label: {
										show: true,
										formatter: function (obj) {
											let value = obj.name;
											return value.length > 12 ? value.substring(0, 10) + "..." : value;
										}
									},
									labelLine: {
										show: true
									}
								}
							},

						}
					]



				}}
			/>)
	}
}